import { useTypedDispatch } from 'features/reduxhooks/ReduxHooks';
import { IOrderSpecificationsModel } from 'models/OrderSpecifications.Model';
import React, { InputHTMLAttributes, useEffect, useState } from 'react'
import { Card, CardBody, Col, Input, Label, Row } from 'reactstrap';
import { useFieldArray, useForm } from "react-hook-form";
import { CustomNumberOnlyBox } from 'components/shared/CustomNumberOnlyBox';
import { CustomTextBox } from 'components/shared/CustomTextBox';
import { CustomButton } from 'components/shared/CustomButton';
import CommonService from 'services/CommonService';
import { pageChange } from 'features/reducers/DocumentScan/PageChange.Reducer';
import { HelperConstant } from '../../helpers/HelperConstant';
import { isMobile, onKeyDown, restrictInput } from '../../helpers/Helper';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    statusId: any;
    ProductTypeName?: any,
    encryptedOrderId: any,
    tabHandler: any,
    activeTab: any,
    setActiveTab: any
}

type FormValues = {
    device: {
        Active?: boolean
        Created?: any
        CreatedBy?: any
        IEMIVerified?: any
        IMEINumber: string
        Id?: any
        IsValid?: boolean
        Modified?: any
        ModifiedBy?: any
        OrderId?: any
        RowOrder?: any
        id?: any
    }[];
};

function ImeiNumber({ statusId, ProductTypeName, encryptedOrderId, tabHandler, activeTab, setActiveTab, ...rest }: inputProps, ref) {
    let dispatch = useTypedDispatch();
    const maxInt32 = Math.pow(2, 31) - 1;
    const [ImeiNumber, setImeiNumber] = useState<Array<IOrderSpecificationsModel>>();
    const [showEdit, setShowEdit] = useState(true);
    const [deleteIMEINumber, setDeleteIMEINumber] = useState<Array<any>>([]);
    // const [fields, setFields] = useState<Array<any>>([{
    //     IMEINumber: "",
    //     IEMIVerified: 1,
    //     OrderId: orderId,
    //     RowOrder: 100,
    //     Active: true
    // }]);

    const { register, control, handleSubmit, formState: { errors }, reset, watch, setValue, getValues,trigger } = useForm<FormValues>({
        defaultValues: {
            device: [{ IMEINumber: "", IEMIVerified: 1, OrderId: 0, RowOrder: 100, Active: true }]
        },
        mode: "onChange",
        criteriaMode: "all",
    });

    const { fields, append, remove } = useFieldArray({
        name: "device",
        control
    });

    const onSubmit = (data: FormValues) => {
        if (ImeiNumber?.length === 0) {
            CommonService.post('orderSpecifications', 'SubmitOrderSpecifications', data.device).then((res) => {
                if (res.status === 200) {
                    tabHandler(dispatch(pageChange("UploadImagePage")))
                    setActiveTab(2)
                    dispatch(pageChange("UploadImagePage"));
                }
            });
        }
        else {
            CommonService.postWithFormDataWithQueryParam('orderSpecifications', 'UpdateOrderSpecifications', data.device, "encryptedOrderId", encryptedOrderId, "application/json-patch+json").then((res) => {
                if (res.status === 200) {
                    tabHandler(dispatch(pageChange("UploadImagePage")))
                    setActiveTab(2)
                    dispatch(pageChange("UploadImagePage"));
                }
            });
        }
    }

    const deleteIMEI = (fields: any, indexs: number, field: any) => {
        const deleteState = deleteIMEINumber.map((obj: any, index: number) => {
            if (indexs === index) {
                return { ...obj, Active: false };
            }
            return obj;
        });
        setDeleteIMEINumber(deleteState)
        remove(indexs);
        CommonService.postWithFormDataWithQueryParam('orderSpecifications', 'UpdateOrderSpecifications', deleteState, "encryptedOrderId", encryptedOrderId, "application/json-patch+json").then((res) => {
            if (res.status === 200) {
            }
        });
    }


    const PreviousBtn = () => {
        window.location.href = (`/agent-ticket-view/${encryptedOrderId}`)
    }

    useEffect(() => {
        CommonService.getWithSingleEntity('orderSpecifications', 'GetSpecificationsByOrderId', encryptedOrderId).then(res => {
            if (res.status === 200) {
                // reset(res.data);
                setDeleteIMEINumber(res.data)
                const result = res.data.filter((x: IOrderSpecificationsModel) => x.Active === true)
                // setTimeout(() => {
                reset({ device: res.data });
                // }, 1000);
                setImeiNumber(res.data);
                if ((statusId === HelperConstant.StatusId.CANCELLED || statusId === HelperConstant.StatusId.COMPLETED || statusId === HelperConstant.StatusId.FAILED) && res?.data?.length > 0) {
                    setShowEdit(false);
                }
            }
        });
    }, [reset, watch]);


    return (
        <React.Fragment>
            <Card className='p-0'>
                <CardBody>
                    <div className='mb-2'>
                        <i className='fas fa-hashtag text-dofy me-2 font-size-15'></i>
                        {ProductTypeName === "Phone" ? <span className='font-size-16 fw-semibold text-dofy'>IMEI Number</span> : <span className='font-size-14 fw-semibold text-dofy'>Serial Number</span>}
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {fields.map((field, index) => (
                            <div>
                                <Row>
                                    <Col xl={8} lg={8} md={8} sm={8} xs={8}>
                                        <>
                                            <Label className="mb-1">{`${ProductTypeName === "Phone" ? `IMEI Number ${index + 1}` : `SERIAL Number ${index + 1}`} `} </Label>

                                            <Input
                                                inputMode={ProductTypeName === "Phone" ? "numeric" : "text"}
                                                type="text"
                                                onKeyDown={ProductTypeName == "Phone" ? onKeyDown : () => { }}
                                                value={watch(`device.${index}.IMEINumber`)}
                                                maxLength={ProductTypeName === "Phone" ? 15 : maxInt32}
                                                {...register(`device.${index}.IMEINumber` as const, {
                                                    required: true, maxLength: ProductTypeName === "Phone" ? 15 : maxInt32, minLength: ProductTypeName === "Phone" ? 15 : 1,
                                                    validate: (value) => {
                                                        const allValues = getValues("device");
                                                        const duplicateCount = allValues.filter((item) => item.IMEINumber === value).length;
                                                        return duplicateCount <= 1 || "Duplicate IMEI/Serial Number is not allowed";
                                                    },
                                                    onChange: (e) => { setValue(`device.${index}.IMEINumber`, e.target.value); restrictInput(e, ProductTypeName === "Phone" ? 15 : maxInt32);trigger("device"); }
                                                })}
                                                className={errors?.device?.[index]?.IMEINumber ? "error" : "mb-2"}
                                            />
                                            {errors?.device?.[index]?.IMEINumber?.message === "Duplicate IMEI/Serial Number is not allowed" && (
                                                <p className='text-danger'>Duplicate IMEI/Serial Number is not allowed</p>
                                            )}
                                            {ProductTypeName === "Phone" ?
                                                <>
                                                    {errors?.device?.[index]?.IMEINumber?.type === "required" ? <p className='text-danger'>Please Enter IMEI Number *</p> : ""}
                                                    {errors?.device?.[index]?.IMEINumber?.type === "minLength" ? <p className='text-danger'>IMEI Number should be 15 digits</p> : ""}
                                                    {errors?.device?.[index]?.IMEINumber?.type === "maxLength" ? <p className='text-danger'>IMEI Number should be 15 digits</p> : ""}
                                                </> :
                                                <>
                                                    {errors?.device?.[index]?.IMEINumber?.type === "required" ? <p className='text-danger'>Please Enter Serial Number *</p> : ""}
                                                    {errors?.device?.[index]?.IMEINumber?.type === "minLength" ? <p className='text-danger'>Serial Number should be 15 digits</p> : ""}
                                                    {errors?.device?.[index]?.IMEINumber?.type === "maxLength" ? <p className='text-danger'>Serial Number should be 15 digits</p> : ""}
                                                </>}
                                        </>
                                    </Col>
                                    <Col xl={2} lg={2} md={2} sm={4} xs={4}>
                                        <div className='d-flex flex-row justify-content-start mt-4'>
                                            <div className='bg-success text-center p-2 rounded-3 cursor-pointer me-2' onClick={() => append({ IMEINumber: "", IEMIVerified: 1, OrderId: 0, RowOrder: 100, Active: true })} >
                                                <i className={'text-light mx-2 fas fa-plus cursor-pointer'} />
                                            </div>
                                            {index === 0 ? null :
                                                <div className='bg-light text-center p-2 rounded-3 cursor-pointer px-3' onClick={() => deleteIMEI(fields, index, field)} >
                                                    <i className={'text-dark fas fa-trash cursor-pointer'} />
                                                </div>}
                                        </div>
                                    </Col>
                                </Row>

                            </div>
                        ))}
                        <Row className='mt-3'>
                            <Col >
                                {!isMobile() ?
                                    <div className='d-flex justify-content-start'>
                                        <CustomButton type={'button'} btnClassName={'btn-light me-2'} iconClasssName={''} name={'Previous'} onClick={() => PreviousBtn()} />
                                        <CustomButton type={'submit'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Next'} />
                                    </div> :
                                    <div className='d-flex flex-column gap-2'>
                                        <CustomButton type={'button'} btnClassName={'btn-light btn-lg w-lg'} iconClasssName={''} name={'Previous'} onClick={() => PreviousBtn()} />
                                        <CustomButton type={'submit'} btnClassName={'btn-success btn-lg w-lg'} iconClasssName={undefined} name={'Next'} />
                                    </div>}
                            </Col>
                        </Row>
                    </form>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default ImeiNumber




